import Vue from 'vue'
import App from '@/app.vue'
import router from '@/router'
import ZCheckbox from '@/components/z-checkbox'
import ZInput from '@/components/z-input'
import ZDialog from '@/components/z-dialog/dialog'
import zDialog from '@/components/z-dialog/index'
import zMessage from '@/components/z-message/index'
import ModWebHeader from '@/components/mod-web-header'
import { addClass } from '@/utils'
import Znav from '@/components/z-nav'
const zCheckbox = {
  install(Vue) {
    Vue.component('z-checkbox', ZCheckbox)
  }
}

const zInput = {
  install(Vue) {
    Vue.component('z-input', ZInput)
  }
}

Vue.component('z-dialog', ZDialog)
Vue.component('mod-web-header', ModWebHeader)
Vue.component('z-nav', Znav)

const util = {
  install(Vue, name = '$addClass') {
    Object.defineProperty(Vue.prototype, name, { value: addClass })
  }
}
Vue.use(util)
Vue.use(zCheckbox)
Vue.use(zInput)
Vue.use(zDialog)
Vue.use(zMessage)

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
